import './TopProgressLoader.scss';

interface Props {
  isLoading: boolean;
  orange?: boolean;
  backgroundColor: string | undefined;
}

export default function TopProgressLoader({
  isLoading,
  backgroundColor,
}: Props) {
  if (isLoading)
    return (
      <div className='TopProgressLoader position-absolute w-100'>
        <div className='TopProgressLoader__container'>
          <div className='TopProgressLoader__indicator' />
        </div>
      </div>
    );

  return (
    <div className='TopProgressLoader position-absolute w-100'>
      <div className='TopProgressLoader__container'>
        <div
          className='TopProgressLoader__indicator TopProgressLoader__indicator--noAnimation w-100'
          style={{
            backgroundColor,
          }}
        />
      </div>
    </div>
  );
}
